import React from 'react';
import { useSearchParams } from 'react-router-dom';

import { FilterContext, FilterType } from './context';
import { useFilterParams } from './hook';

const FilterProvider = ({ children }: { children: React.ReactNode }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const filters = useFilterParams();

  const updateFilters = (values: Partial<FilterType>) => {
    const newParams = new URLSearchParams(searchParams);

    Object.entries(values).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        newParams.set(key, value.toString());
      } else {
        newParams.delete(key);
      }
    });

    // Reset to page 1 when filters change (unless page is explicitly set)
    if (!('page' in values)) {
      newParams.set('page', '1');
    }

    setSearchParams(newParams);
  };

  return <FilterContext.Provider value={{ filters, updateFilters }}>{children}</FilterContext.Provider>;
};

export { FilterProvider };
